// Created by hejikun on 2017/11/2 0002.
let physicalExamination = [
  {
    path: '/physicalExamination',
    name: '体检列表',
    component: () => import('@/pages/physicalExamination/physicalExamination')
  },
  {
    path: '/physicalExamination_home',
    name: '体检主页',
    component: () => import('@/pages/physicalExamination/physicalExamination_home')
  },
  {
    path: '/physicalExamination_evaluate',
    name: '体检评价',
    component: () => import('@/pages/physicalExamination/physicalExamination_evaluate')
  },
  {
    path: '/physicalExamination_index',
    name: '体检机构主页',
    component: () => import('@/pages/physicalExamination/physicalExamination_index')
  },
  {
    path: '/physicalExamination_inde_detail',
    name: '体检机构详情',
    component: () => import('@/pages/physicalExamination/physicalExamination_inde_detail')
  },
  {
    path: '/physicalExamination_detail',
    name: '套餐详情',
    component: () => import('@/pages/physicalExamination/physicalExamination_detail')
  },
  {
    path: '/physicalExamination_addition',
    name: '套餐自选加项',
    component: () => import('@/pages/physicalExamination/physicalExamination_addition')
  },
  {
    path: '/pay_confirm',
    name: '套餐自选加项',
    component: () => import('@/pages/physicalExamination/pay_confirm')
  },
  {
    path: '/physicalExamination_star_list',
    name: '评价列表',
    component: () => import('@/pages/physicalExamination/physicalExamination_star_list')
  },
  {
    path: '/physicalExamination_order_confirm',
    name: '订单确认',
    component: () => import('@/pages/physicalExamination/physicalExamination_order_confirm')
  },
  {
    path: '/physicalExamination_order_confirm_yunda_juanjing',
    name: '订单确认',
    component: () => import('@/pages/physicalExamination/physicalExamination_order_confirm_yunda_juanjing')
  },
  {
    path: '/physicalExamination_orderList',
    name: '订单列表',
    component: () => import('@/pages/physicalExamination/physicalExamination_orderList')
  },
  {
    path: '/physicalExamination_orderList_yunda_juanjing',
    name: '订单列表',
    component: () => import('@/pages/physicalExamination/physicalExamination_orderList_yunda_juanjing')
  },
  {
    path: '/physicalExamination_orderDetail',
    name: '订单详情',
    component: () => import('@/pages/physicalExamination/physicalExamination_orderDetail')
  },
  {
    path: '/physicalExamination_orderPay',
    name: '订单详情',
    component: () => import('@/pages/physicalExamination/physicalExamination_orderPay')
  },
  {
    path: '/physicalExamination_orderDetail_yunda_juanjing',
    name: '订单详情',
    component: () => import('@/pages/physicalExamination/physicalExamination_orderDetail_yunda_juanjing')
  },
  {
    path: '/physicalExamination_oneList',
    name: '套餐列表',
    component: () => import('@/pages/physicalExamination/physicalExamination_oneList')
  },
  {
    path: '/physicalExamination_oneList_kunhua',
    name: '套餐列表',
    component: () => import('@/pages/physicalExamination/physicalExamination_oneList_kunhua')
  },
  {
    path: '/physicalExamination_oneList_shisan',
    name: '套餐列表',
    component: () => import('@/pages/physicalExamination/physicalExamination_oneList_shisan')
  },
  {
    path: '/physicalExamination_oneList_dian',
    name: '套餐列表',
    component: () => import('@/pages/physicalExamination/physicalExamination_oneList_dian')
  },
  {
    path: '/physicalExamination_publicity',
    name: '胃肠镜预约',
    component: () => import('@/pages/physicalExamination/physicalExamination_publicity')
  },
  {
    path: '/physicalExamination_hot_list',
    name: '体检列表',
    component: () => import('@/pages/physicalExamination/physicalExamination_hot_list')
  },
  {
    path: '/physicalExamination_hot_list_saTCM',
    name: '体检列表',
    component: () => import('@/pages/physicalExamination/physicalExamination_hot_list_saTCM')
  },
  {
    path: '/physicalExamination_report',
    name: '检查报告查询',
    component: () => import('@/pages/physicalExamination/physicalExamination_report')
  },
  {
    path: '/physicalExamination_test',
    name: '体检首页',
    component: () => import('@/pages/physicalExamination/test')
  },
  {
    path: '/physicalExamination_rutuo',
    name: '入托入园体检',
    component: () => import('@/pages/physicalExamination/physicalExamination_rutuo')
  },
  {
    path: '/physicalExamination_new_detail',
    name: '体检订单详情',
    component: () => import('@/pages/physicalExamination/physicalExamination_new_detail')
  },
  {
    path: '/physicalExamination_change_time',
    name: '变更确认',
    component: () => import('@/pages/physicalExamination/physicalExamination_change_time')
  },
  {
    path: '/physicalExamination_change_time_juanjing',
    name: '变更确认',
    component: () => import('@/pages/physicalExamination/physicalExamination_change_time_juanjing')
  },
  {
    path: '/physicalExamination_type_packages',
    name: '体检列表',
    component: () => import('@/pages/physicalExamination/physicalExamination_type_packages')
  },
  {
    path: '/physicalExamination_add_items',
    name: '体检加项',
    component: () => import('@/pages/physicalExamination/physicalExamination_add_items')
  },
  {
    path: '/physicalExamination_additems_order_confirm',
    name: '体检加项',
    component: () => import('@/pages/physicalExamination/physicalExamination_additems_order_confirm')
  },
  {
    path: '/physicalExamination_add_detail',
    name: '体检加项',
    component: () => import('@/pages/physicalExamination/physicalExamination_add_detail')
  },
  {
    path: '/physicalExamination_add_order_list',
    name: '体检加项',
    component: () => import('@/pages/physicalExamination/physicalExamination_add_order_list')
  },
  {
    path: '/physicalExamination_search',
    name: '套餐列表搜索',
    component: () => import('@/pages/physicalExamination/physicalExamination_search')
  },
  {
    path: '/physicalExamination_package_list',
    name: '套餐列表',
    component: () => import('@/pages/physicalExamination/physicalExamination_package_list')
  },
  {
    path: '/physicalExamination_report_search',
    name: '报告查询',
    component: () => import('@/pages/physicalExamination/physicalExamination_report_search')
  },
  {
    path: '/physicalExamination_package_detail',
    name: '套餐详情',
    component: () => import('@/pages/physicalExamination/physicalExamination_package_detail')
  },
  {
    path: '/physicalExamination_ranking_list',
    name: '推荐套餐列表',
    component: () => import('@/pages/physicalExamination/physicalExamination_ranking_list')
  },
  {
    path: '/physicalExamination_recommend_more',
    name: '套餐列表',
    component: () => import('@/pages/physicalExamination/physicalExamination_recommend_more')
  },
  {
    path: '/physicalExamination_filter_packageids',
    name: '套餐列表',
    component: () => import('@/pages/physicalExamination/physicalExamination_filter_packageids')
  },
  {
    path: '/physicalExamination_outside_province',
    name: '上海就医',
    component: () => import('@/pages/physicalExamination/physicalExamination_outside_province')
  },
  {
    path: '/physicalExamination_outside_allpackages',
    name: '套餐列表',
    component: () => import('@/pages/physicalExamination/physicalExamination_outside_allpackages')
  },
  {
    path: '/physicalExamination_outside_orders',
    name: '上海就医',
    component: () => import('@/pages/physicalExamination/physicalExamination_outside_orders')
  },
  {
    path: '/physicalExamination_outside_order_detail',
    name: '上海就医',
    component: () => import('@/pages/physicalExamination/physicalExamination_outside_order_detail')
  },
  {
    path: '/physicalExamination_outside_discribe',
    name: '上海就医',
    component: () => import('@/pages/physicalExamination/physicalExamination_outside_discribe')
  },
  {
    path: '/physicalExamination_outside_package_more',
    name: '上海就医',
    component: () => import('@/pages/physicalExamination/physicalExamination_outside_package_more')
  },
  {
    path: '/kunhua_unit_pe_login',
    name: '团检加项',
    component: () => import('@/pages/physicalExamination/kunhua/kunhua_unit_pe_login.vue')
  },
  {
    path: '/kunhua_unit_pe_add_package',
    name: '团检加项',
    component: () => import('@/pages/physicalExamination/kunhua/kunhua_unit_pe_add_package.vue')
  },
  {
    path: '/physicalExamination_outside_more_hot',
    name: '上海就医',
    component: () => import('@/pages/physicalExamination/physicalExamination_outside_more_hot')
  }
]
export default physicalExamination
